var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78066 1.21934C8.64003 1.07889 8.44941 1 8.25066 1C8.05191 1 7.86129 1.07889 7.72066 1.21934L3.47066 5.46934C3.33021 5.60997 3.25132 5.80059 3.25132 5.99934C3.25132 6.19809 3.33021 6.38871 3.47066 6.52934L7.72066 10.7793C7.86284 10.9118 8.05088 10.9839 8.24518 10.9805C8.43948 10.9771 8.62487 10.8984 8.76228 10.761C8.89969 10.6235 8.97841 10.4382 8.98184 10.2439C8.98526 10.0496 8.91314 9.86152 8.78066 9.71934L5.06066 5.99934L8.78066 2.27934C8.92111 2.13871 9 1.94809 9 1.74934C9 1.55059 8.92111 1.35997 8.78066 1.21934Z",
    fill: "#525355"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowBlack);
export default __webpack_public_path__ + "static/media/left_arrow_black.a12b0b20c38e720d054d8a61186a19ac.svg";
export { ForwardRef as ReactComponent };